














































































































































































import { Component, Vue } from 'vue-property-decorator';
import { getDownloadList, search } from '@/api/data';
import { DateTime } from 'luxon';
import { SearchDataType, DownloadListType } from '../../../common/dist/common';

interface Data {
  no: string;
  name: string;
  email: string;
  measurement: DateTime;
  expect: DateTime;
  doctor: string;
  id: number;
  download: number;
}

type sortFunc = (a: unknown, b: unknown) => number;

const header: { text: string; value: keyof Data; sort?: sortFunc }[] = [
  {
    text: 'Data No.',
    value: 'no',
  },
  {
    text: 'Patient Name',
    value: 'name',
  },
  {
    text: 'Patient ID',
    value: 'email',
  },
  {
    text: 'Measurement',
    value: 'measurement',
    sort: (a, b) => {
      if (a instanceof DateTime && b instanceof DateTime) {
        return a.diff(b).milliseconds;
      }
      return 0;
    },
  },
  {
    text: 'Expecting Date',
    value: 'expect',
    sort: (a, b) => {
      if (a instanceof DateTime && b instanceof DateTime) {
        return a.diff(b).milliseconds;
      }
      return 0;
    },
  },
  {
    text: 'Dr. Name',
    value: 'doctor',
  },
  {
    text: 'Download',
    value: 'download',
  },
];

@Component
export default class Search extends Vue {
  public data: Data[] = [];
  private param: Partial<SearchDataType> = {
    expectingDate: '',
  };

  public loading = false;
  public valid = false;
  private ids: number[] = [];
  private downloadDialog = false;
  private downloadList: DownloadListType = { raw: [], computed: [] };
  private downloadNo = '';
  private downloadId = 0;

  public async onSearch() {
    this.loading = true;
    this.ids = [];

    const param: Partial<SearchDataType> = {};
    (Object.keys(this.param) as (keyof SearchDataType)[]).forEach((v) => {
      if (!this.param[v]) {
        param[v] = undefined;
      } else {
        param[v] = this.param[v];
      }
    });

    if (param.expectingDate) {
      param.expectingDate = DateTime.fromISO(param.expectingDate)
        .toUTC()
        .toISO();
    }
    if (param.measurementDate) {
      param.measurementDate = DateTime.fromISO(param.measurementDate)
        .toUTC()
        .toISO();
    }

    const ret = await search(param);
    if (ret.success) {
      this.data = ret.data.map((v) => ({
        id: v.id,
        no: v.no,
        name: v.patient.name,
        email: v.patient.email,
        measurement: DateTime.fromISO(v.date),
        expect: DateTime.fromISO(v.patient.expectingDate),
        doctor: v.doctor.name,
        download: v.id,
      }));
    }

    this.loading = false;
  }

  public onOpen() {
    if (this.ids.length === 0) {
      return;
    }

    this.ids.sort().forEach((v) => {
      console.log(v);
      console.log(window.open(`/view/${v}`, '_blank'));
    });
  }

  // eslint-disable-next-line class-methods-use-this
  public jsDateFormat(iso: string) {
    return DateTime.fromISO(iso).toLocaleString(
      DateTime.DATE_SHORT,
    );
  }

  // eslint-disable-next-line class-methods-use-this
  public jsDateTimeFormat(date: DateTime) {
    return date.toLocaleString(
      DateTime.DATETIME_SHORT_WITH_SECONDS,
    );
  }

  // eslint-disable-next-line class-methods-use-this
  public get headers() {
    return header;
  }

  public get measureDateOk() {
    return DateTime.fromISO(this.param.measurementDate || '').isValid;
  }

  public get expectingDateOk() {
    return DateTime.fromISO(this.param.expectingDate || '').isValid;
  }

  public async onClickDownload(item: Data) {
    const ret = await getDownloadList(item.id);
    if (ret.success) {
      this.downloadList = ret.data;
      this.downloadNo = item.no;
      this.downloadId = item.id;
      this.downloadDialog = true;
    }
  }

  public rawName(index: number) {
    return `input_${this.downloadNo}_${index.toString().padStart(3, '0')}.bin`;
  }

  public computedName(index: number) {
    return `output_${this.downloadNo}_${index.toString().padStart(3, '0')}.bin`;
  }

  public rawLink(index: number) {
    return `/api/data/download/raw/${this.downloadId}/${index}`;
  }

  public computedLink(index: number) {
    return `/api/data/download/computed/${this.downloadId}/${index}`;
  }

  public downloadAll() {
    const a = document.createElement('a');
    a.href = `/api/data/download/all/${this.downloadId}`;
    a.download = `data_${this.downloadNo}.zip`;
    a.click();
  }
}
